export function getSessionDuration() {
  const val = getCookie('sophia_st')
  if (!val) return null

  const [initTimestamp] = val.split('.')
  const sessionDuration = currentTimestamp() - initTimestamp

  return isNaN(sessionDuration) ? null : sessionDuration
}

export function initSessionDuration() {
  // Get the full _ga_VKCYM382PH cookie
  const gaCookie = getGAClientID()
  let GASessionID = null

  if (gaCookie) {
    // Split the cookie value by dots
    const parts = gaCookie.split('.')

    // The client ID is typically in the second part
    GASessionID = parts[2]
  }

  const val = getCookie('sophia_st')
  const currentTime = currentTimestamp()

  let initTimestamp, initSessionId

  if (val && GASessionID) {
    [initTimestamp, initSessionId] = val.split('.').map(Number)

    if (isNaN(initTimestamp) || initSessionId != GASessionID) {
      initTimestamp = currentTime
    }
  } else {
    initTimestamp = currentTime
  }

  const newCookieValue = `${initTimestamp}.${GASessionID}`
  setCookie('sophia_st', newCookieValue)
}

function getUpperLevelDomain() {
  const domainParts = document.location.hostname.split('.')
  return (domainParts.length > 2) ? domainParts.slice(1).join('.') : domainParts.join('.')
}

function setCookie(name, value, options = {}) {
  options = {
    domain: getUpperLevelDomain(),
    path: '/',
    samesite: 'lax',
    ...options
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value)

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey
    let optionValue = options[optionKey]
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue
    }
  }

  document.cookie = updatedCookie
}

function getCookie(name) {
  const matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + "=([^;]*)"
  ))

  return matches ? decodeURIComponent(matches[1]) : undefined
}

function currentTimestamp() {
  return Math.round(new Date().getTime() / 1000)
}

function getGAClientID() {
  const name = '_ga_VKCYM382PH=' // SOPHIA GA cookie
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')

  for(let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
        c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
    }
  }
  return null
}
